"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
var LevelStatus = function LevelStatus(_ref) {
  var project = _ref.project;
  var _ref2 = (0, _react.useState)(null),
    _ref3 = _slicedToArray(_ref2, 2),
    battery = _ref3[0],
    setBattery = _ref3[1];
  var _ref4 = (0, _react.useState)(navigator.onLine),
    _ref5 = _slicedToArray(_ref4, 2),
    isOnline = _ref5[0],
    setIsOnline = _ref5[1];
  var _ref6 = (0, _react.useState)(0),
    _ref7 = _slicedToArray(_ref6, 2),
    startY = _ref7[0],
    setStartY = _ref7[1];
  var _ref8 = (0, _react.useState)(false),
    _ref9 = _slicedToArray(_ref8, 2),
    isSwipingUp = _ref9[0],
    setIsSwipingUp = _ref9[1];
  var _ref0 = (0, _react.useState)('-70px'),
    _ref1 = _slicedToArray(_ref0, 2),
    bottom = _ref1[0],
    setBottom = _ref1[1];
  var handleTouchStart = function handleTouchStart(e) {
    // Récupère la position de départ du doigt ou de la souris
    var touchStartY = e.touches[0].clientY;
    setStartY(touchStartY);
  };
  var handleTouchEnd = function handleTouchEnd(e) {
    if (isSwipingUp) return;
    // Récupère la position de fin du doigt ou de la souris
    var touchEndY = e.changedTouches[0].clientY;

    // Si le mouvement est vers le haut (position de fin est plus basse que celle de départ)
    if (startY - touchEndY >= 10) {
      setIsSwipingUp(true);
      setBottom('0px');
      setTimeout(function () {
        setBottom('-70px');
        setIsSwipingUp(false);
      }, 5000);
    }
    setStartY(0);
  };

  // Pour la souris, on peut utiliser onMouseDown et onMouseUp de manière similaire
  var handleMouseDown = function handleMouseDown(e) {
    setStartY(e.clientY);
  };
  var handleMouseUp = function handleMouseUp(e) {
    if (isSwipingUp) return;
    if (startY - e.clientY >= 10) {
      setIsSwipingUp(true);
      setBottom('0px');
      setTimeout(function () {
        setBottom('-70px');
        setIsSwipingUp(false);
      }, 5000);
    }
    setStartY(0);
  };
  (0, _react.useEffect)(function () {
    // Vérifier si l'API Battery est disponible
    if ('getBattery' in navigator) {
      navigator.getBattery().then(function (battery) {
        var updateBatteryStatus = function updateBatteryStatus() {
          setBattery({
            level: battery.level * 100,
            // Niveau de la batterie en pourcentage
            charging: battery.charging // Si la batterie est en charge
          });
        };

        // Initialiser l'état de la batterie
        updateBatteryStatus();

        // Écouter les événements de changement d'état de la batterie
        battery.addEventListener('chargingchange', updateBatteryStatus);
        battery.addEventListener('levelchange', updateBatteryStatus);

        // Nettoyer les écouteurs d'événements lorsqu'on quitte le composant
        return function () {
          battery.removeEventListener('chargingchange', updateBatteryStatus);
          battery.removeEventListener('levelchange', updateBatteryStatus);
        };
      });
    }
  }, []);

  // Fonction pour mettre à jour l'état de la connexion
  var updateOnlineStatus = function updateOnlineStatus() {
    return setIsOnline(navigator.onLine);
  };
  (0, _react.useEffect)(function () {
    // Écouter les événements de connexion et de déconnexion
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Nettoyage des écouteurs lorsque le composant est démonté
    return function () {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);
  (0, _react.useEffect)(function () {}, [battery]);
  if (!battery) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    style: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      padding: '2em',
      width: '100vw',
      zIndex: 5000,
      backgroundColor: 'rgba(0,0,0,0)'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontFamily: project ? project.default_button_font : 'fantasy',
      transitionDuration: '400ms',
      position: 'fixed',
      bottom: bottom,
      left: 0,
      padding: '10px',
      width: '100vw',
      zIndex: 4000,
      backgroundColor: 'rgba(0,0,0,0.8)',
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      height: '50px'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontSize: '30px',
      margin: '10px'
    }
  }, battery.level.toFixed(0) + '%'), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '10px',
      borderRadius: '50%',
      height: '30px',
      width: '30px',
      backgroundColor: isOnline ? 'green' : 'red',
      position: 'relative',
      top: '0px',
      right: '0px'
    }
  })));
};
var _default = exports.default = LevelStatus;